import styled from "styled-components";
import { HelperText } from "ui/base/helperText/HelperText.jsx";
import { PlusIcon } from "ui/icons/PlusIcon";
import { themeColor } from "ui/theme/index.js";

export const AddPlaceRequest = ({ onPress }) => {
    return (
        <>
            <Container >
                <IconContainer
                    style={{ cursor: "pointer" }}
                    onClick={onPress}
                >
                    <PlusIcon size={22} color="#554DF1" />
                </IconContainer>

                <HelperText
                    color="blue"
                    onClick={onPress}
                    weight="600"
                    style={{ cursor: "pointer" }}
                >
                    if different between in-person and online press here
                </HelperText>
            </Container>
        </>
    );
};

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
`;

const IconContainer = styled.div`
  height: ${({ size }) => (size ? size + "px" : "45px")};
  width: ${({ size }) => (size ? size + "px" : "45px")};
  background-color: ${themeColor("lightBlue")};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
`;
